module.exports = __webpack_public_path__ + "static/subset-UniNeueThin-f877129b87eb1b21f1f6854ae82aabef.woff";